'use client'

import dynamic from 'next/dynamic'

export const ClientDesktopDrawer = dynamic(() => import('./drawer').then(({ Drawer }) => Drawer), {
	ssr: false
})
